<template>
  <div class="playlet">
    <el-card>
      <el-button
        size="mini"
        type="success"
        icon="el-icon-s-help"
        style="float: right;margin-bottom:10px"
        @click="add"
      >创建</el-button>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="name"
            label="名称"
            width="300"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="appId"
            width="200"
            align="center"
          />
          <el-table-column
            prop="app_id"
            label="封面"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.url"
                :fit="'cover'"
                :preview-src-list="[`${scope.row.url}`]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="blurb"
            label="简介"
            width="400"
            align="center"
          />
          <el-table-column
            prop="label"
            label="标签"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center;">
                <div
                  v-for="item,index in scope.row.label"
                  :key="index"
                >{{ item}}，</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="admin_name"
            label="创建人"
            width="200"
            align="center"
          />
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            width="300"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="warning"
                size="small"
                @click="edit(scope.row)"
              >编辑</el-button>
              <el-button
                type="danger"
                size="small"
                @click="myDelete(scope.row.id)"
              >删除</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="小程序游戏设置"
      :visible.sync="cookiedialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="700px"
    >
      <sourdialog
        ref="sourdialogview"
        @updata="updatar"
      />
    </el-dialog>
  </div>
</template>

<script>
import sourdialog from './components/sourdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { gameSettinglist, gameSettingdelete } from '@/api/sourceminiprogram.js'
export default {
  name: 'WechatGame',
  components: {
    PaginationRight,
    sourdialog
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10
      },
      loading: false,
      tableData: [],
      total: null,
      cookiedialogVisible: false
    }
  },

  created() {
    this.getDatas()
  },
  activated() {
    this.getDatas()
  },
  mounted() {},
  methods: {
    add() {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(1)
      })
    },
    edit(item) {
      this.cookiedialogVisible = true
      this.$nextTick(() => {
        this.$refs.sourdialogview.send(2, item)
      })
    },
    async getDatas() {
      this.loading = true
      const data = await gameSettinglist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    // 删除
    myDelete(id) {
      console.log('id', id)
      this.$confirm('此操作将删除游戏小程序, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          gameSettingdelete({
            id: id
          }).then(res => {
            this.getDatas()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10
      }
      this.getDatas()
    },

    updatar() {
      this.cookiedialogVisible = false
      this.getDatas()
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-card {
  height: 70px;
}
</style>

